import script from "./HowToGerminate.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToGerminate.vue?vue&type=script&setup=true&lang=js"

import "./HowToGerminate.vue?vue&type=style&index=0&id=6c6cc13e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6cc13e"]])

export default __exports__